<template lang="pug">

div

    //- Ohne Schreibzugriff
    span(v-show='!isWritable') {{ activeStatusLabel }}

    //- Mit Schreibzugriff
    .ui.dropdown(v-show="isWritable")
        | {{ activeStatusLabel }}

        i.dropdown.icon(v-show='$auth.isZmuekish')

        .menu
            .item(
                v-for='status in availableStatuses'
                v-on:click='change(status.value)'
            ) {{ status.label }}

</template>

<script>
    import { is_any_published as is_any_price_published } from '@/utils/price'
    import { find_status_by_value, get_status_label } from '@/utils/product'
    import * as R from "ramda"

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            activeStatusLabel() {
                return get_status_label(this.productModel.status)
            },

            availableStatuses() {
                switch (this.productModel.status) {
                    case 'OPEN': return [find_status_by_value('IN_PROCESS')]
                    case 'IN_PROCESS': return [find_status_by_value('OFFERS_AVAILABLE')]
                    case 'OFFERS_AVAILABLE': return [find_status_by_value('IN_PROCESS')]
                    case 'OFFER_CONFIRMED': return [find_status_by_value('IN_PRINT')]
                    case 'IN_PRINT': return [find_status_by_value('DELIVERED')]
                    case 'DELIVERED': return [find_status_by_value('QA')]
                    case 'QA': return [find_status_by_value('COMPLETED')]
                    default: return []
                }
            },

            isAnyJobAccepted() {
                return this.jobModels.some(job => job.status === 'ACCEPTED')
            },

            isWritable() {
                // Wenn "In Bearbeitung", dann nur Switch möglich wenn mindestens ein Preis freigegeben
                // noinspection RedundantIfStatementJS
                if (this.productModel.status === 'IN_PROCESS' && !is_any_price_published(this.priceModels)) {
                    return false
                }

                // "Im Druck" nur möglich wenn Druckdatenstatus "Freigabe-PDF bestätigt" ist
                // UND mindestens ein Job für Lieferanten freigegeben wurde (BLAST!)
                if (this.productModel.status === 'OFFER_CONFIRMED') {
                    if (this.productModel.printingDataStatus !== 'FORM_PROOF_CONFIRMED') return false
                    if (!this.isAnyJobAccepted) return false
                }

                return this.availableStatuses.length > 0
            },

            isAnyOfferPublished() {
                return is_any_price_published(this.priceModels)
            },

        },

        mounted() {
            if (this.$auth.isZmuekish) {
                $(this.$el).find('.dropdown').dropdown()
            }
        },

        methods: {

            async change(value) {
                // Model erstellen
                const model = R.assoc('status', value, this.productModel)

                try {
                    // Produkt speichern
                    await this.$store.dispatch('products/update', { id: model.id, model })

                    // Erfolgsmeldung anzeigen
                    this.$growl.success('Status gespeichert')

                } catch (e) {
                    // Fehlermeldung anzeigen
                    this.$growl.fatal('Produkt-Status konnte nicht gespeichert werden', e)
                }
            }

        },

        props: {

            jobModels: {
                type: Array,
                default: () => []
            },

            priceModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            }

        }

    }


</script>
